import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d130d1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-company" }
const _hoisted_2 = { class: "select-company__wrapper" }
const _hoisted_3 = { class: "select-company__label" }
const _hoisted_4 = { class: "select-company__data" }
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("Common.SelectCompany")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCompanyId) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
            return (_openBlock(), _createElementBlock("option", {
              value: company.externalId,
              key: company.externalId
            }, _toDisplayString(company.name), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedCompanyId]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onsubmit())),
          class: "button--base button--primary",
          type: "submit"
        }, _toDisplayString(_ctx.$t('Common.Choose')), 1)
      ])
    ])
  ]))
}